import styled from "styled-components";
import { CtaButton } from "../Reusable/styles";

export const Wrapper = styled.div`
    padding: 6rem 5rem;
    background-color: #f3f6fa;
    background-size: cover;
    display: flex;
    flex-direction: column;

    margin-left: auto;
    margin-right: auto;
    max-width: 1300px;

    @media ${(props) => props.theme.breakpoints.sm} {
        height: fit-content;
    }

    @media ${(props) => props.theme.breakpoints.xs} {
        padding: 6rem 2.5rem;
    }

    & h2 {
        text-align: center;
        margin-bottom: 8rem;
    }
`;

export const GridStats = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 4rem;
    justify-items: center;
    margin-bottom: 4rem;

    @media ${(props) => props.theme.breakpoints.sm} {
        display: flex;
        flex-direction: column;
        align-items: center;

        margin-bottom: 2rem;
    }

    & div {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    & span {
        font-size: 8rem;
        font-weight: 600;
        color: #0e4da4;
    }

    & p {
        margin-top: 3rem;
        font-weight: 400;
        text-align: center;

        @media ${(props) => props.theme.breakpoints.sm} {
            margin-top: 0;
            margin-bottom: 4rem;
            font-size: 2.5rem;
        }
    }
`;

export const Button = styled(CtaButton)`
    padding: 1.5rem 5rem;
    width: 25rem;
    text-align: center;
    align-self: center;
    font-size: 2.5rem;

    transition: all 0.2s;

    &:hover {
        transform: scale(1.04);
    }
`;
